// import React, { useEffect, useState } from "react";
// import {
//   Select,
//   TextInput,
//   Button,
//   Modal,
//   Text,
//   Divider,
//   SegmentedControl,
//   Table,
//   Alert,
//   Group,
//   Stepper,
// } from "@mantine/core";
// import { useForm } from "@mantine/form";
// import flat from "flat";
// import { DatePicker } from "@mantine/dates";
// import { formatISO, parseISO } from "date-fns";
// import { showNotification } from "@mantine/notifications";
// import { useNavigate } from "react-router-dom";
// import { apiWrapWithErrorWithData } from "../../../utilities/apiHelpers";
// import {
//   getAgreementTitleApi,
//   getAgreementTypesApi,
//   getRegisterUserApi,
//   bulkAgreementUploadApi,
//   createBulkAgreements,
//   getTemplateTypesApi,
// } from "../../../utilities/apis/agreements";
// import TemplatesList from "../../../components/TemplateManager/TemplatesList";
// import { downloadCsvApi } from "../../../utilities/apis/templates";
// import styles from "./AgreementBulkCreate.module.css";
// import colors from "../../../utilities/design";
// import AgreementBulkParty from "./AgreementBulkParty";
// import AgreementBulkConfirm from "./AgreementBulkConfirm";
// import AgreementBulkSteps from "./AgreementBulkSteps";
// import { getPartiesList } from "../../../utilities/apis/parties";
// import { handleChangeUpload } from "./utils";
// import { useSelector } from "react-redux";
// import { selectUserData } from "../../../redux/selectors";
// import {
//   getBussinessUnit,
//   getUserRolesUsingRoleId,
// } from "../../../utilities/apis/serviceProvider";
// import { camelCaseToTitle } from "../../../utilities/utilities";
// import { Search } from "tabler-icons-react";
// import { Dropzone } from "@mantine/dropzone";
// import { IconUpload } from "@tabler/icons-react";
// import {
//   getBuDetails,
//   getOrgDetailsFromMaster,
// } from "../../../utilities/apis/users";
// // import { parse } from "json2csv";
// import { format } from "date-fns";

// const AgreementBulkCreate = () => {
//   const currentUser = useSelector(selectUserData);
//   const reminderLabels = {
//     15: "15 days",
//     30: "30 days",
//     45: "45 days",
//     60: "60 days",
//   };
//   const navigate = useNavigate();

//   const [step, setStep] = useState({ lastStep: false });

//   const [typeOfAgreementData, setTypeOfAgreementData] = useState([]);
//   const [agreementTitleData, setAgreementTitleData] = useState([]);
//   const [businessUnitsOptions, setBusinessUnitsOptions] = useState([]);
//   const [requestingUserData, setRequestingUserData] = useState(null);
//   const [file, setFile] = useState(null);
//   const [showupload, setShowUpload] = useState(false);
//   const [intialConfigs, setInitialConfigs] = useState({
//     titleOfAgreement: "",
//     typeOfAgreement: "",
//     dateOfContract: "",
//     noOfMonths: "",
//     noOfYears: "",
//     reminderTime: 0,
//     count: 2,
//     businessUnit: 0,
//     templateId: 0,
//     viewTemplate: false,
//     editorContent: null,
//   });
//   const [formData, setFormData] = useState(null);
//   const [loading, setLoading] = useState(false);
//   const [templateTypes, setTemplateTypes] = useState([]);
//   const [placeholders, setPlaceholders] = useState([]);
  
//   useEffect(() => {
//     const getAgreementTypes = async () => {
//       const resp = await apiWrapWithErrorWithData(getAgreementTypesApi());
//       console.log("1: ", resp);
//       setTypeOfAgreementData(resp.typesOfAgreement);
//     };
//     getAgreementTypes();
//     const getTemplateTypes = async () => {
//       const resp = await apiWrapWithErrorWithData(getTemplateTypesApi());
//       setTemplateTypes(resp.templates);
//     };
//     getTemplateTypes();
//   }, []);
//   useEffect(() => {
//     const getAgreementTitle = async () => {
//       const resp = await apiWrapWithErrorWithData(getAgreementTitleApi());
//       console.log("2 : ", resp);
//       setAgreementTitleData(resp.titlesOfAgreement);
//     };
//     getAgreementTitle();
//   }, []);
//   useEffect(() => {
//     const getRegisterUser = async () => {
//       const res = await apiWrapWithErrorWithData(getRegisterUserApi());
//       setRequestingUserData({
//         requestingUserName: res.requestingUser.name,
//         requestingUserEmail: res.requestingUser.email,
//         requestingUserPhone: res.requestingUser.phone,
//         requestingUserDesignation: res.requestingUser.designation,
//         requestingUserBusinessDepartment: res.requestingUser.businessDepartment,
//       });
//       console.log("3: ", requestingUserData);
//     };
//     getRegisterUser();
//   }, []);

//   useEffect(() => {
//     const fetchBusinessUnits = async () => {
//       try {
//         const { data } = await getBussinessUnit();
//         if (data) {
//           setBusinessUnitsOptions(
//             data.result.map((unit) => ({
//               value: unit.id + "",
//               label: unit.name,
//             })) || []
//           );
//         } else {
//           console.error("Invalid business unit response format:", data);
//         }
//       } catch (error) {
//         console.error("Error fetching business units:", error);
//       }
//     };
//     fetchBusinessUnits();
//   }, []);


//   const downloadCsvHandler = async () => {
//   if (!intialConfigs.templateId || intialConfigs.templateId === 0) {
//     showNotification({
//       title: "Bulk Agreement Form",
//       message: "Please Select the agreement template",
//       color: "red",
//     });
//     return;
//   }

//   const res = await apiWrapWithErrorWithData(
//     downloadCsvApi({ templateId: intialConfigs.templateId })
//   );
  
//   // Note: Your response.result might be an array or object based on your previous logs
//   const response = await apiWrapWithErrorWithData(
//     getBuDetails({ id: parseInt(intialConfigs.businessUnit) })
//   );

//   if (res.success && response.success) {
//     const { data } = res;
    
//     // Check if result is nested in an array or direct object
//     const buDetails = response.result?.details || response.result?.[0]?.details || {};

//     // 1. USE INTERNAL CAMELCASE KEYS (The backend maps these to 'arg')
//     const columns = [
//       "businessUnit",
//       "templateId",
//       "typeOfAgreement",
//       "titleOfAgreement",
//       "requestingUserName",
//       "requestingUserEmail",
//       "dateOfContract",
//       "noOfYears",
//       "noOfMonths",
//       "reminderTimeInDays",
//       "firstPartyName",
//       "firstPartyEmail",
//       "firstPartyAddress",
//       "firstPartySignatory",
//       "firstPartyRepresentative",
//       "secondPartyType",
//       "secondPartyEntityType",
//       "secondPartyName",
//       "secondPartyBrandName",
//       "secondPartyEmail",
//       "secondPartyAddress",
//       "secondPartySignatory",
//       "secondPartyRepresentative",
//       "agreementValue",
//       "location"
//     ];

//     // 2. SAFE PLACEHOLDERS (Prevents the .forEach crash)
//     const safeFieldNames = Array.isArray(data.fieldName) ? data.fieldName : [];
//     const placeholderColumns = safeFieldNames.map((ele) => `ph_${ele}`);

//     const allKeys = [...columns, ...placeholderColumns];

//     // 3. PRE-FILL DATA
//     const preFiledValues = {
//       "businessUnit": intialConfigs.businessUnit,
//       "templateId": intialConfigs.templateId,
//       "typeOfAgreement": intialConfigs.typeOfAgreement || "",
//       "titleOfAgreement": intialConfigs.titleOfAgreement || "",
//       "requestingUserName": requestingUserData.requestingUserName || "",
//       "requestingUserEmail": requestingUserData.requestingUserEmail || "",
//       // FIX: Ensure simple YYYY-MM-DD format
//       "dateOfContract": intialConfigs.dateOfContract, 
//       "noOfYears": intialConfigs.noOfYears || "0",
//       "noOfMonths": intialConfigs.noOfMonths || "0",
//       "reminderTimeInDays": intialConfigs.reminderTime || "15",
//       "firstPartyName": currentUser.userOrgs?.name || "",
//       "firstPartyEmail": buDetails.signEmail || "",
//       "firstPartyAddress": buDetails.copAddress || "",
//       "firstPartySignatory": buDetails.signName || "",
//       "firstPartyRepresentative": buDetails.poc || "",
//       "secondPartyType": "Entity",
//       "secondPartyEntityType": "Company",
//       "agreementValue": 0,
//       "location": ""
//     };

//     // 4. GENERATE HEADERS (Convert camelCase to Title for the CSV display)
//     const headerRow = allKeys.map(k => k.startsWith('ph_') ? k : camelCaseToTitle(k)).join(",");

//     // 5. GENERATE DATA ROW
//     const dataRow = allKeys.map((key) => {
//       const value = preFiledValues[key] ?? ""; 
//       return `"${String(value).replace(/"/g, '""')}"`;
//     }).join(",");

//     let csvContent = headerRow + "\n";
//     const count = parseInt(intialConfigs.count) || 1;
//     for (let i = 0; i < count; i++) {
//       csvContent += dataRow + "\n";
//     }

//     const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
//     const url = URL.createObjectURL(blob);
//     const link = document.createElement("a");
//     link.href = url;
//     link.setAttribute("download", `${data.name || "template"}.csv`);
//     document.body.appendChild(link);
//     link.click();
//     document.body.removeChild(link);
    
//     setShowUpload(true);
//   }
// };
  
//   function validate() {
//     if (flowJson["7"]?.length > 0) {
//       return true;
//     } else if (flowJson["7"].length === 0) {
//       return false;
//     }
//   }
//   const uploadHandler = async (files) => {
//     setFile(files[0]);
//     console.log("file: ", files[0]);
//     let filetosend = files[0];
//     const [csvData, formData] = await handleChangeUpload({ file: filetosend });

//     console.log("csvData: ", csvData);

//     setFormData(csvData);

//     console.log("form Data: ", formData);
//     // setStep({ lastStep: true });
//   };

//   const [flowJson, setFLowJson] = useState({
//     3: [],
//     4: [],
//     5: [],
//     6: [],
//     7: [],
//     sendfordirectsign: false,
//   });
//   const loginAsId = Number(currentUser.loginAs.id);
//   const [signauthData, setSignauthData] = useState([]);

//   useEffect(() => {
//     const getSignauth = async () => {
//       const signauths = await getUserRolesUsingRoleId(7);
//       setSignauthData(signauths.data.result);
//       console.log(signauthData);
//     };
//     getSignauth();
//   }, []);

//   useEffect(() => {
//     if (loginAsId === 3) {
//       setFLowJson({
//         3: [
//           {
//             userId: currentUser.id,
//             isComplete: false,
//           },
//         ],
//         4: [],
//         5: [],
//         6: [],
//         7: [],
//         sendfordirectsign: true,
//       });
//     } else if (loginAsId === 4) {
//       setFLowJson({
//         3: [],
//         4: [
//           {
//             userId: currentUser.id,
//             isComplete: false,
//           },
//         ],
//         5: [],
//         6: [],
//         7: [],
//         sendfordirectsign: false,
//       });
//     }
//   }, [loginAsId]);

 
//   const back = () => {
//     setStep({ lastStep: false });
//   };

  
//   const onSubmit = async () => {
//   if (!file) {
//     showNotification({ title: "Error", message: "Please upload a CSV file", color: "red" });
//     return;
//   }

//   setLoading(true);

//   // Note: flowJson is usually an object that needs to be stringified for the backend
//   const formDataObject = new FormData();
//   formDataObject.append("file", file); // The file from your Dropzone/Input
//   formDataObject.append("flowJson", JSON.stringify(flowJson));

//   try {
//     const res = await createBulkAgreements({ formDataObject }); // Ensure your API helper handles FormData
//     debugger

//     if (res.status === 200) {
//       showNotification({
//         title: "Success",
//         message: "Bulk agreements created successfully",
//         color: "green",
//       });
//       navigate("/app/agreements_manager/agreements-list");
//     } else {
//       throw new Error(res.error || "Upload failed");
//     }
//   } catch (error) {
//     console.error("Bulk upload error:", error);
//     showNotification({
//       title: "Error",
//       message: "Backend crashed or invalid data. Ensure Template placeholders match CSV.",
//       color: "red",
//     });
//   } finally {
//     setLoading(false);
//   }
// };

//   return (
//     <div className="mx-2">
//       <Stepper
//         active={
//           formData
//             ? 2
//             : !formData && showupload
//               ? 1
//               : !formData && !showupload
//                 ? 0
//                 : 0
//         }
//       >
//         {/* {!step.lastStep && (
//         <div> */}
//         {/* {!showupload ? ( */}
//         {/* <> */}
//         <Stepper.Step label="Enter Key Details">
//           <div className="mx-4">
//             <Text
//               className=" mt-4"
//             >
//               fill in the key details and download the CSV template:
//             </Text>
//             <div className="w-full flex flex-col my-4">
//               <div>
//                 <div className="grid grid-cols-2 my-4">
//                   <Select
//                     required
//                     searchable
//                     creatable
//                     className="max-w-lg"
//                     label="contract type"
//                     placeholder="select type of contract"
//                     data={typeOfAgreementData}
//                     onChange={(val) => {
//                       setInitialConfigs({
//                         ...intialConfigs,
//                         typeOfAgreement: val,
//                       });
//                     }}
//                     value={intialConfigs.typeOfAgreement}
//                   />
//                   <Select
//                     required
//                     searchable
//                     creatable
//                     className="max-w-lg"
//                     label="contract title"
//                     placeholder="select contract title"
//                     data={agreementTitleData}
//                     value={intialConfigs.titleOfAgreement}
//                     onChange={(val) => {
//                       setInitialConfigs({
//                         ...intialConfigs,
//                         titleOfAgreement: val,
//                       });
//                     }}
//                   />
//                 </div>
//                 <div className="grid grid-cols-2 my-4">
//                   <DatePicker
//                     required
//                     className="max-w-lg"
//                     label="date of contract"
//                     placeholder="select date"
//                     onChange={(val) =>
//                       setInitialConfigs({
//                         ...intialConfigs,
//                         dateOfContract: val ? format(val, "yyyy-MM-dd") : "",
//                       })
//                     }
//                     value={
//                       intialConfigs.dateOfContract
//                         ? new Date(intialConfigs.dateOfContract)
//                         : null
//                     }
//                   />
//                   <Select
//                     required
//                     placeholder="reminder time"
//                     label="renewal reminder time (in days)"
//                     className="max-w-lg"
//                     data={[
//                       { value: 15, label: reminderLabels["15"] },
//                       { value: 30, label: reminderLabels["30"] },
//                       { value: 45, label: reminderLabels["45"] },
//                       { value: 60, label: reminderLabels["60"] },
//                     ]}
//                     onChange={(val) =>
//                       setInitialConfigs({
//                         ...intialConfigs,
//                         reminderTime: val,
//                       })
//                     }
//                   />
//                 </div>
//                 <div className=" my-4 ">
//                   <Text>contract term</Text>
//                   <div className="grid grid-cols-2">
//                     <div className="grid grid-cols-2 max-w-lg">
//                       <div className="mr-4">
//                         <div
//                           className="flex flex-row justify-between"
//                           style={{ width: "200px" }}
//                         >
//                           <Select
//                             required
//                             label="duration"
//                             placeholder="select years"
//                             data={[
//                               ...Array.from({ length: 11 }, (_, i) => ({
//                                 value: `${i}`,
//                                 label: `${i} year${i === 1 ? "" : "s"}`,
//                               })),
//                               { value: "100", label: "100 years" },
//                             ]}
//                             onChange={(val) =>
//                               setInitialConfigs({
//                                 ...intialConfigs,
//                                 noOfYears: val,
//                               })
//                             }
//                             style={{ width: "160px", marginRight: "20px" }}
//                           />
//                           <Select
//                             label="   "
//                             placeholder="select months"
//                             data={[
//                               { value: "0", label: "0 month" },
//                               ...Array.from({ length: 12 }, (_, i) => ({
//                                 value: `${i + 1}`,
//                                 label: `${i + 1} month${
//                                   i === 0 || i === 1 ? "" : "s"
//                                 }`,
//                               })),
//                             ]}
//                             onChange={(val) =>
//                               setInitialConfigs({
//                                 ...intialConfigs,
//                                 noOfMonths: val,
//                               })
//                             }
//                             style={{ width: "160px" }}
//                           />
//                         </div>
//                       </div>
//                       <TextInput
//                         required
//                         className="ml-4"
//                         label="agreements count"
//                         placeholder="count"
//                         type="number"
//                         // style={{ width: "200px", marginRight: "20px" }}
//                         onChange={(e) =>
//                           setInitialConfigs({
//                             ...intialConfigs,
//                             count: e.target.value,
//                           })
//                         }
//                         value={intialConfigs.count}
//                       />
//                     </div>
//                     {/* <Button
//                       style={{
//                         backgroundColor: "#46BDE1",
//                       }}
//                       className="max-w-lg mt-5 mb-0"
//                       onClick={(e) =>
//                         setInitialConfigs({
//                           ...intialConfigs,
//                           viewTemplate: true,
//                         })
//                       }
//                     >
//                       choose agreement template
//                     </Button> */}
//                     <div className="flex flex-row justify-end max-w-lg  ">
//                       <Select
//                         data={templateTypes.map((template) => ({
//                           label: template.name,
//                           value: template.id,
//                         }))}
//                         style={{
//                           width: "82%",
//                         }}
//                         label="select template"
//                         placeholder="select template"
//                         value={intialConfigs.templateId}
//                         onChange={(val) =>
//                           setInitialConfigs({
//                             ...intialConfigs,
//                             templateId: val,
//                           })
//                         }
//                       />
//                       <Button
//                         className="max-w-lg mt-6"
//                         color="#1b6f8d"
//                         // onClick={handleSearchClick} // Call the handler on button click
//                         style={{
//                           width: "12%",
//                           display: "inline-block",
//                           marginBottom: "0",
//                           // marginTop: "auto",
//                           marginLeft: "6%",
//                           padding: "0",
//                           // backgroundColor: "#46BDE1",
//                         }}
//                         onClick={(e) =>
//                           setInitialConfigs({
//                             ...intialConfigs,
//                             viewTemplate: true,
//                           })
//                         }
//                       >
//                         <Search size={20} strokeWidth={3} />
//                       </Button>
//                     </div>
//                   </div>
//                 </div>
//                 <div className=" grid grid-cols-2  my-4">
//                   <Select
//                     required
//                     searchable
//                     className="max-w-lg"
//                     placeholder="enter business unit"
//                     label="Business Unit"
//                     data={businessUnitsOptions}
//                     dropdownPosition="bottom"
//                     onChange={(val) =>
//                       setInitialConfigs({
//                         ...intialConfigs,
//                         businessUnit: val,
//                       })
//                     }
//                   />
//                   <Select
//                     required
//                     placeholder="select sign-auth"
//                     label="sign-auth"
//                     className="max-w-lg"
//                     data={signauthData?.map((user) => ({
//                       value: user.id,
//                       label: user.name,
//                     }))}
//                     value={flowJson["7"][0]?.userId}
//                     onChange={(val) => {
//                       setFLowJson({
//                         ...flowJson,
//                         7: [{ userId: val, isComplete: false }],
//                       });
//                     }}
//                   />
//                   <div></div>
//                   <div className="flex  justify-end mt-10 mr-8">
//                     <Button
//                       className="flex justify-end"
//                       onClick={() => downloadCsvHandler()}
//                     >
//                       next
//                     </Button>
//                   </div>
//                 </div>
//               </div>
//               {/* <Divider className="my-4" /> */}
//             </div>
//           </div>
//         </Stepper.Step>
//         {/* </> */}
//         {/* // ) : ( */}
//         <Stepper.Step label="Upload CSV File">
//           <div>
//             <Text
              
//               className=" mt-4"
//             >
//               upload the completed CSV file for validation:
//             </Text>
//             <div className={styles["upload-wrapper"]}>
//               <Dropzone
//                 onDrop={(files) => {
//                   uploadHandler(files);
//                 }}
//                 style={{ width: "80%", marginTop: "5%" }}
//               >
//                 <Group
//                   position="center"
//                   spacing="xl"
//                   style={{ minHeight: 100, pointerEvents: "none" }}
//                 >
//                   <IconUpload
//                     // status={status}
//                     style={{
//                       width: 80,
//                       height: 80,
//                       color: "#5F6464",
//                     }}
//                   />

//                   <div>
//                     <Text size="xl" inline>
//                       {file === null
//                         ? "drag csv file here or click to select csv files"
//                         : `${file.name}`}
//                     </Text>
//                     <Text size="sm" color="dimmed" inline mt={7}></Text>
//                   </div>
//                 </Group>
//               </Dropzone>
//             </div>

//             {formData !== null && (
//               <div className="flex justify-end mr-8">
//                 <Button
//                   className="flex justify-end"
//                   onClick={() => setStep({ lastStep: true })}
//                   // style={{
//                   //   backgroundColor: "#46BDE1",
//                   // }}
//                   // disabled={!step.lastStep}
//                 >
//                   next
//                 </Button>
//               </div>
//             )}
//           </div>
//         </Stepper.Step>
//         {/* // )} */}
//         {/* </div>
//       )} */}

//         {/* {formData !== null && step.lastStep && ( */}
//         <Stepper.Step label="Confirm Submission">
//           <AgreementBulkConfirm
//             bulkAgreementData={formData}
//             onPrevious={back}
//             onSubmit={onSubmit}
//             loading={loading}
//           />
//         </Stepper.Step>
//         {/* // )} */}
//       </Stepper>
//       <Modal
//         overflow="inside"
//         opened={intialConfigs.viewTemplate}
//         onClose={() => {
//           setInitialConfigs({ ...intialConfigs, viewTemplate: false });
//         }}
//         size="calc(80vw)"
//       >
//         <TemplatesList
//           showNewTemplateBtn={false}
//           templateType="Agreements"
//           placeholders={placeholders}
//           setPlaceholders={setPlaceholders}
//           useTemplateFunc={(template) => {
//             console.log({
//               template,
//             });
//             setInitialConfigs({
//               ...intialConfigs,
//               templateId: template.id,
//               editorContent: template.quillDelta,
//               viewTemplate: false,
//             });
//           }}
//         />
//       </Modal>
//     </div>
//   );
// };

// export default AgreementBulkCreate;

import React, { useEffect, useState } from "react";
import {
  Select,
  TextInput,
  Button,
  Modal,
  Text,
  Divider,
  SegmentedControl,
  Table,
  Alert,
  Group,
  Stepper,
} from "@mantine/core";
import { useForm } from "@mantine/form";
import flat from "flat";
import { DatePicker } from "@mantine/dates";
import { formatISO, parseISO } from "date-fns";
import { showNotification } from "@mantine/notifications";
import { useNavigate } from "react-router-dom";
import { apiWrapWithErrorWithData } from "../../../utilities/apiHelpers";
import {
  getAgreementTitleApi,
  getAgreementTypesApi,
  getRegisterUserApi,
  bulkAgreementUploadApi,
  createBulkAgreements,
  getTemplateTypesApi,
} from "../../../utilities/apis/agreements";
import TemplatesList from "../../../components/TemplateManager/TemplatesList";
import { downloadCsvApi } from "../../../utilities/apis/templates";
import styles from "./AgreementBulkCreate.module.css";
import colors from "../../../utilities/design";
import AgreementBulkParty from "./AgreementBulkParty";
import AgreementBulkConfirm from "./AgreementBulkConfirm";
import AgreementBulkSteps from "./AgreementBulkSteps";
import { getPartiesList } from "../../../utilities/apis/parties";
import { handleChangeUpload } from "./utils";
import { useSelector } from "react-redux";
import { selectUserData } from "../../../redux/selectors";
import {
  getBussinessUnit,
  getUserRolesUsingRoleId,
} from "../../../utilities/apis/serviceProvider";
import { camelCaseToTitle } from "../../../utilities/utilities";
import { Search } from "tabler-icons-react";
import { Dropzone } from "@mantine/dropzone";
import { IconUpload } from "@tabler/icons-react";
import {
  getBuDetails,
  getOrgDetailsFromMaster,
} from "../../../utilities/apis/users";
// import { parse } from "json2csv";
import { format } from "date-fns";

const AgreementBulkCreate = () => {
  const currentUser = useSelector(selectUserData);
  const reminderLabels = {
    15: "15 days",
    30: "30 days",
    45: "45 days",
    60: "60 days",
  };
  const navigate = useNavigate();

  const [step, setStep] = useState({ lastStep: false });

  const [typeOfAgreementData, setTypeOfAgreementData] = useState([]);
  const [agreementTitleData, setAgreementTitleData] = useState([]);
  const [businessUnitsOptions, setBusinessUnitsOptions] = useState([]);
  const [requestingUserData, setRequestingUserData] = useState(null);
  const [file, setFile] = useState(null);
  const [showupload, setShowUpload] = useState(false);
  const [intialConfigs, setInitialConfigs] = useState({
    titleOfAgreement: "",
    typeOfAgreement: "",
    dateOfContract: "",
    contractEndDate: "",
    noOfMonths: "",
    noOfYears: "",
    reminderTime: 0,
    count: 2,
    businessUnit: 0,
    templateId: 0,
    viewTemplate: false,
    editorContent: null,
  });
  const [formData, setFormData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [templateTypes, setTemplateTypes] = useState([]);
  const [placeholders, setPlaceholders] = useState([]);
  
  useEffect(() => {
    const getAgreementTypes = async () => {
      const resp = await apiWrapWithErrorWithData(getAgreementTypesApi());
      console.log("1: ", resp);
      setTypeOfAgreementData(resp.typesOfAgreement);
    };
    getAgreementTypes();
    const getTemplateTypes = async () => {
      const resp = await apiWrapWithErrorWithData(getTemplateTypesApi());
      setTemplateTypes(resp.templates);
    };
    getTemplateTypes();
  }, []);
  useEffect(() => {
    const getAgreementTitle = async () => {
      const resp = await apiWrapWithErrorWithData(getAgreementTitleApi());
      console.log("2 : ", resp);
      setAgreementTitleData(resp.titlesOfAgreement);
    };
    getAgreementTitle();
  }, []);
  useEffect(() => {
    const getRegisterUser = async () => {
      const res = await apiWrapWithErrorWithData(getRegisterUserApi());
      setRequestingUserData({
        requestingUserName: res.requestingUser.name,
        requestingUserEmail: res.requestingUser.email,
        requestingUserPhone: res.requestingUser.phone,
        requestingUserDesignation: res.requestingUser.designation,
        requestingUserBusinessDepartment: res.requestingUser.businessDepartment,
      });
      console.log("3: ", requestingUserData);
    };
    getRegisterUser();
  }, []);

  useEffect(() => {
    const fetchBusinessUnits = async () => {
      try {
        const { data } = await getBussinessUnit();
        if (data) {
          setBusinessUnitsOptions(
            data.result.map((unit) => ({
              value: unit.id + "",
              label: unit.name,
            })) || []
          );
        } else {
          console.error("Invalid business unit response format:", data);
        }
      } catch (error) {
        console.error("Error fetching business units:", error);
      }
    };
    fetchBusinessUnits();
  }, []);


// const downloadCsvHandler = async () => {
//   if (!intialConfigs.templateId || intialConfigs.templateId === 0) {
//     showNotification({ title: "Bulk Agreement Form", message: "Please Select the agreement template", color: "red" });
//     return;
//   }

//   const res = await apiWrapWithErrorWithData(downloadCsvApi({ templateId: intialConfigs.templateId }));
//   const response = await apiWrapWithErrorWithData(getBuDetails({ id: parseInt(intialConfigs.businessUnit) }));

//   if (res.success && response.success) {
//     const { data } = res;
//     const buDetails = response.result?.details || response.result?.[0]?.details || {};

//     // 1. YOUR ORIGINAL COLUMN LOGIC (Do not change)
//     const columns = [
//       "businessUnit", "templateId", "typeOfAgreement", "titleOfAgreement",
//       "requestingUserName", "requestingUserEmail", "dateOfContract",
//       "noOfYears", "noOfMonths", "reminderTimeInDays", "firstPartyName",
//       "firstPartyEmail", "firstPartyAddress", "firstPartySignatory",
//       "firstPartyRepresentative", "secondPartyType", "secondPartyEntityType",
//       "secondPartyName", "secondPartyBrandName", "secondPartyEmail",
//       "secondPartyAddress", "secondPartySignatory", "secondPartyRepresentative",
//       "agreementValue", "location"
//     ];

//     const safeFieldNames = Array.isArray(data.fieldName) ? data.fieldName : [];
//     const placeholderColumns = safeFieldNames.map((ele) => `ph_${ele}`);
//     const allKeys = [...columns, ...placeholderColumns];

//     const rows = [];
    
//     // ROW 1: INSTRUCTIONS
//     rows.push("INSTRUCTIONS: Rows 1 & 2 are for reference. Data must start from Row 4. Format Dates: DD/MM/YYYY. Mandatory: All except Brand Name and Location.");

//     // ROW 2: SAMPLE DATA (Populating mandatory fields with sample strings)
//     const sampleRow = allKeys.map(key => {
//       if (key === "secondPartyBrandName" || key === "location") return '""';
//       if (key.startsWith("ph_")) return '"Sample Value"';
//       return '"Sample"'; // Default for other mandatory fields
//     }).join(",");
//     rows.push(sampleRow);

//     // ROW 3: HEADERS (Mapping keys to Title Case for user friendliness)
//     const headerRow = allKeys.map(k => k.startsWith('ph_') ? k : camelCaseToTitle(k)).join(",");
//     rows.push(headerRow);

//     // ROW 4+: AUTO-POPULATE DATA (Your original pre-fill logic)
//     const preFiledValues = {
//       "businessUnit": intialConfigs.businessUnit,
//       "templateId": intialConfigs.templateId,
//       "typeOfAgreement": intialConfigs.typeOfAgreement || "",
//       "titleOfAgreement": intialConfigs.titleOfAgreement || "",
//       "requestingUserName": requestingUserData.requestingUserName || "",
//       "requestingUserEmail": requestingUserData.requestingUserEmail || "",
//       "dateOfContract": intialConfigs.dateOfContract ? format(new Date(intialConfigs.dateOfContract), "dd/MM/yyyy") : "",
//       "noOfYears": intialConfigs.noOfYears || "0",
//       "noOfMonths": intialConfigs.noOfMonths || "0",
//       "reminderTimeInDays": intialConfigs.reminderTime || "15",
//       "firstPartyName": currentUser.userOrgs?.name || "",
//       "firstPartyEmail": buDetails.signEmail || "",
//       "firstPartyAddress": buDetails.copAddress || "",
//       "firstPartySignatory": buDetails.signName || "",
//       "firstPartyRepresentative": buDetails.poc || "",
//       "secondPartyType": "Entity",
//       "secondPartyEntityType": "Company",
//       "agreementValue": 0,
//     };

//     const dataRow = allKeys.map((key) => {
//       const value = preFiledValues[key] ?? ""; 
//       return `"${String(value).replace(/"/g, '""')}"`;
//     }).join(",");

//     const count = parseInt(intialConfigs.count) || 1;
//     for (let i = 0; i < count; i++) {
//       rows.push(dataRow);
//     }

//     const csvContent = rows.join("\n");
//     const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
//     const url = URL.createObjectURL(blob);
//     const link = document.createElement("a");
//     link.href = url;
//     link.setAttribute("download", `${data.name || "Bulk_Template"}.csv`);
//     document.body.appendChild(link);
//     link.click();
//     document.body.removeChild(link);
//     setShowUpload(true);
//   }
// };
  const downloadCsvHandler = async () => {
  if (!intialConfigs.templateId || intialConfigs.templateId === 0) {
    showNotification({ title: "Bulk Agreement Form", message: "Please Select the agreement template", color: "red" });
    return;
  }

  const res = await apiWrapWithErrorWithData(downloadCsvApi({ templateId: intialConfigs.templateId }));
  const response = await apiWrapWithErrorWithData(getBuDetails({ id: parseInt(intialConfigs.businessUnit) }));

  if (res.success && response.success) {
    const { data } = res;
    const buDetails = response.result?.details || response.result?.[0]?.details || {};

    const columns = [
      "businessUnit", "templateId", "typeOfAgreement", "titleOfAgreement",
      "requestingUserName", "requestingUserEmail", "dateOfContract",
      "contractEndDate", "noOfYears", "noOfMonths", "reminderTimeInDays", "firstPartyName",
      "firstPartyEmail", "firstPartyAddress", "firstPartySignatory",
      "firstPartyRepresentative", "secondPartyType", "secondPartyEntityType",
      "secondPartyName", "secondPartyBrandName", "secondPartyEmail",
      "secondPartyAddress", "secondPartySignatory", "secondPartyRepresentative",
      "agreementValue", "location"
    ];

    const safeFieldNames = Array.isArray(data.fieldName) ? data.fieldName : [];
    const placeholderColumns = safeFieldNames.map((ele) => `ph_${ele}`);
    const allKeys = [...columns, ...placeholderColumns];

    const rows = [];
    
    // ROW 1: INSTRUCTIONS
    rows.push("INSTRUCTIONS: Rows 1 & 2 are for reference. Data must start from Row 4. Format Dates: DD-MM-YYYY. Provide either duration (No Of Years/No Of Months) or Contract End Date. If both are provided, Contract End Date is used. Mandatory: All except Brand Name and Location.");

    // ROW 2: ENHANCED SAMPLE DATA MAPPING
    const sampleValuesMap = {
      businessUnit: "1",
      templateId: "11",
      typeOfAgreement: "Service Level Agreement",
      titleOfAgreement: "Annual Maintenance Contract",
      requestingUserName: "John Doe",
      requestingUserEmail: "john.doe@example.com",
      dateOfContract: "01-01-2024",
      contractEndDate: "31-12-2024",
      noOfYears: "1",
      noOfMonths: "0",
      reminderTimeInDays: "30",
      firstPartyName: "Entity Name",
      firstPartyEmail: "legal@yourcompany.com",
      firstPartyAddress: "123 Business Park, City",
      firstPartySignatory: "Jane Smith",
      firstPartyRepresentative: "Michael Scott",
      secondPartyType: "Entity/Individual",
      secondPartyEntityType: "Company/LLP/Proprietorship",
      secondPartyName: "Individual/Entity Name",
      secondPartyBrandName: "", // Optional
      secondPartyEmail: "contact@vendor.com",
      secondPartyAddress: "456 Vendor Lane, City",
      secondPartySignatory: "Robert Brown",
      secondPartyRepresentative: "Dwight Schrute",
      agreementValue: "123",
      location: "", // Optional
    };

    const sampleRow = allKeys.map(key => {
      // Handle ph_ placeholders
      if (key.startsWith("ph_")) return '"Custom Value"';
      
      // Get value from map or default to a generic "Value"
      const val = sampleValuesMap[key] !== undefined ? sampleValuesMap[key] : "Value";
      return `"${val}"`;
    }).join(",");
    
    rows.push(sampleRow);

    // ROW 3: HEADERS
    const headerRow = allKeys.map(k => k.startsWith('ph_') ? k : camelCaseToTitle(k)).join(",");
    rows.push(headerRow);

    // ROW 4+: AUTO-POPULATE DATA
    const preFiledValues = {
      "businessUnit": intialConfigs.businessUnit,
      "templateId": intialConfigs.templateId,
      "typeOfAgreement": intialConfigs.typeOfAgreement || "",
      "titleOfAgreement": intialConfigs.titleOfAgreement || "",
      "requestingUserName": requestingUserData.requestingUserName || "",
      "requestingUserEmail": requestingUserData.requestingUserEmail || "",
      "dateOfContract": intialConfigs.dateOfContract ? format(new Date(intialConfigs.dateOfContract), "dd/MM/yyyy") : "",
      "contractEndDate": intialConfigs.contractEndDate ? format(new Date(intialConfigs.contractEndDate), "dd/MM/yyyy") : "",
      "noOfYears": intialConfigs.noOfYears || "0",
      "noOfMonths": intialConfigs.noOfMonths || "0",
      "reminderTimeInDays": intialConfigs.reminderTime || "15",
      "firstPartyName": currentUser.userOrgs?.name || "",
      "firstPartyEmail": buDetails.signEmail || "",
      "firstPartyAddress": buDetails.copAddress || "",
      "firstPartySignatory": buDetails.signName || "",
      "firstPartyRepresentative": buDetails.poc || "",
      "secondPartyType": "Entity",
      "secondPartyEntityType": "Company",
      "agreementValue": 0,
    };

    const dataRow = allKeys.map((key) => {
      const value = preFiledValues[key] ?? ""; 
      return `"${String(value).replace(/"/g, '""')}"`;
    }).join(",");

    const count = parseInt(intialConfigs.count) || 1;
    for (let i = 0; i < count; i++) {
      rows.push(dataRow);
    }

    const csvContent = rows.join("\n");
    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", `${data.name || "Bulk_Template"}.csv`);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    setShowUpload(true);
  }
};

  function validate() {
    if (flowJson["7"]?.length > 0) {
      return true;
    } else if (flowJson["7"].length === 0) {
      return false;
    }
  }
  const uploadHandler = async (files) => {
    setFile(files[0]);
    console.log("file: ", files[0]);
    let filetosend = files[0];
    const [csvData, formData] = await handleChangeUpload({ file: filetosend });

    console.log("csvData: ", csvData);

    setFormData(csvData);

    console.log("form Data: ", formData);
    // setStep({ lastStep: true });
  };

  const [flowJson, setFLowJson] = useState({
    3: [],
    4: [],
    5: [],
    6: [],
    7: [],
    sendfordirectsign: false,
  });
  const loginAsId = Number(currentUser.loginAs.id);
  const [signauthData, setSignauthData] = useState([]);

  useEffect(() => {
    const getSignauth = async () => {
      const signauths = await getUserRolesUsingRoleId(7);
      setSignauthData(signauths.data.result);
      console.log(signauthData);
    };
    getSignauth();
  }, []);

  useEffect(() => {
    if (loginAsId === 3) {
      setFLowJson({
        3: [
          {
            userId: currentUser.id,
            isComplete: false,
          },
        ],
        4: [],
        5: [],
        6: [],
        7: [],
        sendfordirectsign: true,
      });
    } else if (loginAsId === 4) {
      setFLowJson({
        3: [],
        4: [
          {
            userId: currentUser.id,
            isComplete: false,
          },
        ],
        5: [],
        6: [],
        7: [],
        sendfordirectsign: false,
      });
    }
  }, [loginAsId]);

 
  const back = () => {
    setStep({ lastStep: false });
  };

  
const onSubmit = async () => {
  if (!file) {
    showNotification({ title: "Error", message: "Please upload a CSV file", color: "red" });
    return;
  }
  setLoading(true);

  try {
    const fileText = await file.text();
    const lines = fileText.split(/\r?\n/);
    
    // Improved search: remove spaces and lowercase everything to find the match
    const headerIndex = lines.findIndex(line => {
      const cleanLine = line.toLowerCase().replace(/\s/g, "");
      return cleanLine.includes("typeofagreement");
    });

    if (headerIndex === -1) {
      throw new Error("CSV Header not found. Please use the original template.");
    }

    // Slice to remove metadata rows (Instructions & Sample)
    const cleanCsvContent = lines.slice(headerIndex).join("\n");
    const cleanFile = new File([cleanCsvContent], file.name, { type: "text/csv" });

    const formDataObject = new FormData();
    formDataObject.append("file", cleanFile); 
    formDataObject.append("flowJson", JSON.stringify(flowJson));

    const res = await createBulkAgreements({ formDataObject });

    if (res.status === 200) {
      showNotification({ title: "Success", message: "Bulk agreements created", color: "green" });
      navigate("/app/agreements_manager/agreements-list");
    } else {
      throw new Error("Backend Error");
    }
  } catch (error) {
    showNotification({ title: "Error", message: error.message, color: "red" });
  } finally {
    setLoading(false);
  }
};
  return (
    <div className="mx-2">
      <Stepper
        active={
          formData
            ? 2
            : !formData && showupload
              ? 1
              : !formData && !showupload
                ? 0
                : 0
        }
      >
        {/* {!step.lastStep && (
        <div> */}
        {/* {!showupload ? ( */}
        {/* <> */}
        <Stepper.Step label="Enter Key Details">
          <div className="mx-4">
            <Text
              className=" mt-4"
            >
              fill in the key details and download the CSV template:
            </Text>
            <div className="w-full flex flex-col my-4">
              <div>
                <div className="grid grid-cols-2 my-4">
                  <Select
                    required
                    searchable
                    creatable
                    className="max-w-lg"
                    label="contract type"
                    placeholder="select type of contract"
                    data={typeOfAgreementData}
                    onChange={(val) => {
                      setInitialConfigs({
                        ...intialConfigs,
                        typeOfAgreement: val,
                      });
                    }}
                    value={intialConfigs.typeOfAgreement}
                  />
                  <Select
                    required
                    searchable
                    creatable
                    className="max-w-lg"
                    label="contract title"
                    placeholder="select contract title"
                    data={agreementTitleData}
                    value={intialConfigs.titleOfAgreement}
                    onChange={(val) => {
                      setInitialConfigs({
                        ...intialConfigs,
                        titleOfAgreement: val,
                      });
                    }}
                  />
                </div>
                <div className="grid grid-cols-2 my-4">
                  <DatePicker
                    required
                    className="max-w-lg"
                    label="date of contract"
                    placeholder="select date"
                    onChange={(val) =>
                      setInitialConfigs({
                        ...intialConfigs,
                        dateOfContract: val ? format(val, "yyyy-MM-dd") : "",
                      })
                    }
                    value={
                      intialConfigs.dateOfContract
                        ? new Date(intialConfigs.dateOfContract)
                        : null
                    }
                  />
                  <Select
                    required
                    placeholder="reminder time"
                    label="renewal reminder time (in days)"
                    className="max-w-lg"
                    data={[
                      { value: 15, label: reminderLabels["15"] },
                      { value: 30, label: reminderLabels["30"] },
                      { value: 45, label: reminderLabels["45"] },
                      { value: 60, label: reminderLabels["60"] },
                    ]}
                    onChange={(val) =>
                      setInitialConfigs({
                        ...intialConfigs,
                        reminderTime: val,
                      })
                    }
                  />
                </div>
                <div className="grid grid-cols-2 my-4">
                  <DatePicker
                    className="max-w-lg"
                    label="contract end date"
                    placeholder="select end date"
                    onChange={(val) =>
                      setInitialConfigs({
                        ...intialConfigs,
                        contractEndDate: val ? format(val, "yyyy-MM-dd") : "",
                      })
                    }
                    value={
                      intialConfigs.contractEndDate
                        ? new Date(intialConfigs.contractEndDate)
                        : null
                    }
                  />
                  <div />
                </div>
                <div className=" my-4 ">
                  <Text>contract term</Text>
                  <div className="grid grid-cols-2">
                    <div className="grid grid-cols-2 max-w-lg">
                      <div className="mr-4">
                        <div
                          className="flex flex-row justify-between"
                          style={{ width: "200px" }}
                        >
                          <Select
                            required
                            label="duration"
                            placeholder="select years"
                            data={[
                              ...Array.from({ length: 11 }, (_, i) => ({
                                value: `${i}`,
                                label: `${i} year${i === 1 ? "" : "s"}`,
                              })),
                              { value: "100", label: "100 years" },
                            ]}
                            onChange={(val) =>
                              setInitialConfigs({
                                ...intialConfigs,
                                noOfYears: val,
                              })
                            }
                            style={{ width: "160px", marginRight: "20px" }}
                          />
                          <Select
                            label="   "
                            placeholder="select months"
                            data={[
                              { value: "0", label: "0 month" },
                              ...Array.from({ length: 12 }, (_, i) => ({
                                value: `${i + 1}`,
                                label: `${i + 1} month${
                                  i === 0 || i === 1 ? "" : "s"
                                }`,
                              })),
                            ]}
                            onChange={(val) =>
                              setInitialConfigs({
                                ...intialConfigs,
                                noOfMonths: val,
                              })
                            }
                            style={{ width: "160px" }}
                          />
                        </div>
                      </div>
                      <TextInput
                        required
                        className="ml-4"
                        label="agreements count"
                        placeholder="count"
                        type="number"
                        // style={{ width: "200px", marginRight: "20px" }}
                        onChange={(e) =>
                          setInitialConfigs({
                            ...intialConfigs,
                            count: e.target.value,
                          })
                        }
                        value={intialConfigs.count}
                      />
                    </div>
                    {/* <Button
                      style={{
                        backgroundColor: "#46BDE1",
                      }}
                      className="max-w-lg mt-5 mb-0"
                      onClick={(e) =>
                        setInitialConfigs({
                          ...intialConfigs,
                          viewTemplate: true,
                        })
                      }
                    >
                      choose agreement template
                    </Button> */}
                    <div className="flex flex-row justify-end max-w-lg  ">
                      <Select
                        required
                        data={templateTypes.map((template) => ({
                          label: template.name,
                          value: template.id,
                        }))}
                        style={{
                          width: "82%",
                        }}
                        label="select template"
                        placeholder="select template"
                        value={intialConfigs.templateId}
                        onChange={(val) =>
                          setInitialConfigs({
                            ...intialConfigs,
                            templateId: val,
                          })
                        }
                      />
                      <Button
                        className="max-w-lg mt-6"
                        color="#1b6f8d"
                        // onClick={handleSearchClick} // Call the handler on button click
                        style={{
                          width: "12%",
                          display: "inline-block",
                          marginBottom: "0",
                          // marginTop: "auto",
                          marginLeft: "6%",
                          padding: "0",
                          // backgroundColor: "#46BDE1",
                        }}
                        onClick={(e) =>
                          setInitialConfigs({
                            ...intialConfigs,
                            viewTemplate: true,
                          })
                        }
                      >
                        <Search size={20} strokeWidth={3} />
                      </Button>
                    </div>
                  </div>
                </div>
                <div className=" grid grid-cols-2  my-4">
                  <Select
                    required
                    searchable
                    className="max-w-lg"
                    placeholder="enter business unit"
                    label="Business Unit"
                    data={businessUnitsOptions}
                    dropdownPosition="bottom"
                    onChange={(val) =>
                      setInitialConfigs({
                        ...intialConfigs,
                        businessUnit: val,
                      })
                    }
                  />
                  <Select
                    required
                    placeholder="select sign-auth"
                    label="sign-auth"
                    className="max-w-lg"
                    data={signauthData?.map((user) => ({
                      value: user.id,
                      label: user.name,
                    }))}
                    value={flowJson["7"][0]?.userId}
                    onChange={(val) => {
                      setFLowJson({
                        ...flowJson,
                        7: [{ userId: val, isComplete: false }],
                      });
                    }}
                  />
                  <div></div>
                  <div className="flex  justify-end mt-10 mr-8">
                    <Button
                      className="flex justify-end"
                      onClick={() => downloadCsvHandler()}
                    >
                      next
                    </Button>
                  </div>
                </div>
              </div>
              {/* <Divider className="my-4" /> */}
            </div>
          </div>
        </Stepper.Step>
        {/* </> */}
        {/* // ) : ( */}
        <Stepper.Step label="Upload CSV File">
          <div>
            <Text
              
              className=" mt-4"
            >
              upload the completed CSV file for validation:
            </Text>
            <div className={styles["upload-wrapper"]}>
              <Dropzone
                onDrop={(files) => {
                  uploadHandler(files);
                }}
                style={{ width: "80%", marginTop: "5%" }}
              >
                <Group
                  position="center"
                  spacing="xl"
                  style={{ minHeight: 100, pointerEvents: "none" }}
                >
                  <IconUpload
                    // status={status}
                    style={{
                      width: 80,
                      height: 80,
                      color: "#5F6464",
                    }}
                  />

                  <div>
                    <Text size="xl" inline>
                      {file === null
                        ? "drag csv file here or click to select csv files"
                        : `${file.name}`}
                    </Text>
                    <Text size="sm" color="dimmed" inline mt={7}></Text>
                  </div>
                </Group>
              </Dropzone>
            </div>

            {formData !== null && (
              <div className="flex justify-end mr-8">
                <Button
                  className="flex justify-end"
                  onClick={() => setStep({ lastStep: true })}
                  // style={{
                  //   backgroundColor: "#46BDE1",
                  // }}
                  // disabled={!step.lastStep}
                >
                  next
                </Button>
              </div>
            )}
          </div>
        </Stepper.Step>
        {/* // )} */}
        {/* </div>
      )} */}

        {/* {formData !== null && step.lastStep && ( */}
        <Stepper.Step label="Confirm Submission">
          <AgreementBulkConfirm
            bulkAgreementData={formData}
            onPrevious={back}
            onSubmit={onSubmit}
            loading={loading}
          />
        </Stepper.Step>
        {/* // )} */}
      </Stepper>
      <Modal
        overflow="inside"
        opened={intialConfigs.viewTemplate}
        onClose={() => {
          setInitialConfigs({ ...intialConfigs, viewTemplate: false });
        }}
        size="calc(80vw)"
      >
        <TemplatesList
          showNewTemplateBtn={false}
          templateType="Agreements"
          placeholders={placeholders}
          setPlaceholders={setPlaceholders}
          useTemplateFunc={(template) => {
            console.log({
              template,
            });
            setInitialConfigs({
              ...intialConfigs,
              templateId: template.id,
              editorContent: template.quillDelta,
              viewTemplate: false,
            });
          }}
        />
      </Modal>
    </div>
  );
};

export default AgreementBulkCreate;
